import React, { memo } from 'react'

import { Button, Icon, Search } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function NoResults({ onCreate }) {
  const t = useTranslation()

  return (
    <div className="image-assistant-search-tab__state">
      <div className="image-assistant-search-tab__empty-icon">
        <Icon svgComponent={Search} size={iconSizeMedium} color="dark" notSpaced />
      </div>
      <div className="image-assistant-search-tab__empty-text">
        <p className="image-assistant-search-tab__state-title cgt-heading-200">
          {t('imageAssistantPanel.searchTab.noResults.title')}
        </p>
        <p className="image-assistant-search-tab__state-subtitle cgt-body-md">
          {t('imageAssistantPanel.searchTab.noResults.subtitle')}
        </p>
      </div>
      <Button type="secondary" size="small" onClick={onCreate}>
        {t('imageAssistantPanel.searchTab.noResults.create')}
      </Button>
    </div>
  )
}

NoResults.propTypes = {
  onCreate: func.isRequired,
}

export default memo(NoResults)
